import React, { useState } from 'react';

const UPDATES = [
  {
    date:    'June 17, 2026',
    title:   'DBOS Installable as an App! 📲',
    content: 'DBOS now installs to your home screen on mobile — full app experience, Golden D and all.',
  },
  {
    date:    'June 15, 2026',
    title:   'DBOS SmartData is Live! 🚀',
    content: 'Our first SmartSuite solution is live: AI-powered file storage, automatic categorization, and intelligent search.',
  },
  {
    date:    'June 12, 2026',
    title:   'AI Classification & Content Hub Live',
    content: 'Every upload is now automatically read, labeled, and organized by AI — documents, images, spreadsheets, and more.',
  },
  {
    date:    'June 8, 2026',
    title:   'Subscription Plans Live',
    content: 'Choose the plan that fits — Starter through Premium, with secure checkout built in.',
  },
  {
    date:    'May 2026',
    title:   'Welcome to DBOS',
    content: 'We started building the Digital Business Operating System for SMEs — onboarding our first SmartClients.',
  },
];

function UpdatesFeed() {
  const [openIndex, setOpenIndex] = useState(null);
  const [showAll, setShowAll]     = useState(false);

  const visibleUpdates = showAll ? UPDATES : UPDATES.slice(0, 1);

  return (
    <div className="section">
      <div
        className="section-header-collapsible"
        onClick={() => setShowAll(!showAll)}
      >
        <h2 className="section-title">📰 SmartClient Updates</h2>
        <span className="section-toggle">{showAll ? '▲' : '▼'}</span>
      </div>

      <div className="updates-feed">
        {visibleUpdates.map((update, index) => (
          <div
            key={index}
            className={`update-card ${openIndex === index ? 'open' : ''}`}
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
          >
            <div className="update-card-header">
              <span className="update-card-title">{update.title}</span>
              <span className="update-card-arrow">
                {openIndex === index ? '▲' : '▼'}
              </span>
            </div>
            {openIndex === index && (
              <div className="update-card-body">
                <div className="update-card-date">{update.date}</div>
                <div className="update-card-content">{update.content}</div>
              </div>
            )}
          </div>
        ))}

        {UPDATES.length > 1 && (
          <button
            className="updates-show-more"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? '▲ Show less' : `▼ Show ${UPDATES.length - 1} more updates`}
          </button>
        )}
      </div>
    </div>
  );
}

export default UpdatesFeed;